module.exports = __webpack_public_path__ + "static/level-5-logo.afd239a9.png";